import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferSection() {
  const includes = ['📘 Ebook PDF completo (30 días)', '🎧 4 Meditaciones guiadas en MP4', '📓 Libreta de Gratitud y Provisión (PDF imprimible)', '📲 Acceso y descarga inmediata', '🔒 Garantía 7 días'];
  return <section id="offer" className="w-full bg-navy text-white py-16 md:py-24" data-id="element-257">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-258">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-259">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-gold mb-12 text-center" data-id="element-260">
            Empieza hoy por menos de lo que cuesta un café.
          </h2>

          <div className="bg-white/10 backdrop-blur-sm rounded-lg overflow-hidden mb-8" data-id="element-261">
            <div className="bg-gold text-navy p-4" data-id="element-262">
              <h3 className="text-xl font-bold text-center" data-id="element-263">
                ✅ Lo que obtienes
              </h3>
            </div>
            <div className="p-6" data-id="element-264">
              {includes.map((item, index) => <div key={index} className="flex items-center justify-between py-3 border-b border-white/20 last:border-0" data-id="element-265">
                  <span className="text-white/90" data-id="element-266">{item}</span>
                  <span className="text-gold font-semibold" data-id="element-267">Incluido</span>
                </div>)}
              <div className="flex items-center justify-between py-4 mt-4 border-t-2 border-gold" data-id="element-268">
                <span className="text-xl font-bold text-gold" data-id="element-269">
                  💰 Total hoy
                </span>
                <span className="text-3xl font-bold text-gold" data-id="element-270">$6.36</span>
              </div>
            </div>
          </div>

          <div className="text-center mb-6" data-id="element-271">
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} className="relative mx-auto max-w-2xl mb-8" data-id="element-272">
              <div className="absolute -inset-4 bg-gold/10 rounded-2xl blur-xl" data-id="element-273" />
              <img src="https://cdn.magicpatterns.com/uploads/avzq1JdVHEwdGpDFzhX4n6/heylloyd-image-1775364722702.png" alt="Mockup completo — 30 Días con Dios: Ebook, Meditaciones y Libreta de Gratitud" className="relative w-full rounded-xl shadow-2xl" data-id="element-274" />
            </motion.div>
            <motion.a href="https://pay.hotmart.com/A105236382M" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="inline-block bg-gold text-dark font-bold px-12 py-5 rounded-lg text-xl shadow-2xl hover:brightness-110 transition-all" data-id="element-275">
              Quiero mi acceso ahora — $6.36 →
            </motion.a>
          </div>

          <div className="text-center" data-id="element-276">
            <p className="text-amber-300 font-semibold" data-id="element-277">
              ⚠️ Este es el precio de lanzamiento. Puede aumentar sin previo
              aviso.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}